// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LKJO5","buttons":"styles_buttons__3-va9"};